// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --darkbrown1: #452600;
  --darkbrown2: #743e00;
  --orange4: #a25500;
  --orange5: #d16c00;
  --orange6: #ff8300;
  --darkgrey: #3c4858;
  --pink: #e91e63;
  --light-pink: rgba(233,30,99,0.65098);

  --usabt-blue: #00aef3;
  --usabt-blue-dark: #007cba;


  --shell-bg-color: var(--white);
  --shell-color: var(--darkgrey);
  --header-bg-color: var(--pink);
  --menu-bg-color: var(--white);
  --menu-color: var(--darkgrey);
  --menu-color-active: var(--white);

  --border-dark-color: var(--pink);
  --btn-bg-color: var(--pink);
  --border-dark-bg-color: var(--light-pink);
  --btn-dark-bg-color: var(--light-pink);

  --theme-dark-color: var(--orange4);
  --theme-color: var(--light-pink);
  --theme-light-color: var(--pink);

  --tracking-bg-color: var(--usabt-blue);
  --tracking-border: var(--usabt-blue-dark);
  --tracking-btn-color: var(--white);
  --tracking-btn-border-color: var(--darkbrown1);

  --shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
}
`, "",{"version":3,"sources":["webpack://./beach/components/theme.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,qCAAuB;;EAEvB,qBAAqB;EACrB,0BAA0B;;;EAG1B,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;EAC9B,6BAA6B;EAC7B,6BAA6B;EAC7B,iCAAiC;;EAEjC,gCAAgC;EAChC,2BAA2B;EAC3B,yCAAyC;EACzC,sCAAsC;;EAEtC,kCAAkC;EAClC,gCAAgC;EAChC,gCAAgC;;EAEhC,sCAAsC;EACtC,yCAAyC;EACzC,kCAAkC;EAClC,8CAA8C;;EAE9C,gEAAgE;AAClE","sourcesContent":[":root {\r\n  --darkbrown1: #452600;\r\n  --darkbrown2: #743e00;\r\n  --orange4: #a25500;\r\n  --orange5: #d16c00;\r\n  --orange6: #ff8300;\r\n  --darkgrey: #3c4858;\r\n  --pink: #e91e63;\r\n  --light-pink: #e91e63a6;\r\n\r\n  --usabt-blue: #00aef3;\r\n  --usabt-blue-dark: #007cba;\r\n\r\n\r\n  --shell-bg-color: var(--white);\r\n  --shell-color: var(--darkgrey);\r\n  --header-bg-color: var(--pink);\r\n  --menu-bg-color: var(--white);\r\n  --menu-color: var(--darkgrey);\r\n  --menu-color-active: var(--white);\r\n\r\n  --border-dark-color: var(--pink);\r\n  --btn-bg-color: var(--pink);\r\n  --border-dark-bg-color: var(--light-pink);\r\n  --btn-dark-bg-color: var(--light-pink);\r\n\r\n  --theme-dark-color: var(--orange4);\r\n  --theme-color: var(--light-pink);\r\n  --theme-light-color: var(--pink);\r\n\r\n  --tracking-bg-color: var(--usabt-blue);\r\n  --tracking-border: var(--usabt-blue-dark);\r\n  --tracking-btn-color: var(--white);\r\n  --tracking-btn-border-color: var(--darkbrown1);\r\n\r\n  --shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
